import api from './api';

const BASE = '/plan-mantenimiento';

export const planMantenimientoService = {
    listar: async (filtros = {}) => {
        const response = await api.get(`${BASE}/`, { params: filtros });
        return response.data;
    },

    obtener: async (id) => {
        const response = await api.get(`${BASE}/${id}`);
        return response.data;
    },

    crear: async (data) => {
        const response = await api.post(`${BASE}/`, data);
        return response.data;
    },

    actualizar: async (id, data) => {
        const response = await api.put(`${BASE}/${id}`, data);
        return response.data;
    },

    eliminar: async (id) => {
        const response = await api.delete(`${BASE}/${id}`);
        return response.data;
    },

    cargarExcel: async (file) => {
        const formData = new FormData();
        formData.append('file', file);
        const response = await api.post(`${BASE}/upload-excel`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return response.data;
    },

    descargarPlantilla: async () => {
        const response = await api.get(`${BASE}/plantilla/excel`, { responseType: 'blob' });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Plantilla_Plan_Mantenimiento.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
    },

    generarAhora: async () => {
        const response = await api.post(`${BASE}/generar-ahora`);
        return response.data;
    },
};
